import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { BatchDetailsNavigator } from '@v2/pages/batch/details/navigation/BatchDetailsNavigator';
import { NCFileDetailsNavigator } from '@v2/pages/nc-file/details/navigation/NCFileDetailsNavigator';
import { PartDetailsNavigator } from '@v2/pages/part/details/navigation/PartDetailsNavigator';
import { JobDetailsNavigator } from '@v2/pages/job/navigation/JobDetailsNavigator';
import { ToolsDetailsNavigator } from '@v2/pages/tools/details/navigation/ToolsDetailsNavigator';
import { ProductionOrderDetailsNavigator } from '@v2/pages/productionOrder/navigation/ProductionOrderDetailsNavigator';
import { BatchDetailsScreenName } from '@v2/pages/batch/details/navigation/config';
import { NCFileDetailsScreenName } from '@v2/pages/nc-file/details/navigation/config';
import { PartDetailsScreenName } from '@v2/pages/part/details/navigation/config';
import { JobDetailsScreenName } from '@v2/pages/job/navigation/config';
import { ToolsDetailsScreenName } from '@v2/pages/tools/details/navigation/config';
import { ProductionOrderDetailsScreenName } from '@v2/pages/productionOrder/navigation/config';
import { BOTTOM_SHEET_NAVIGATION_CONFIG, BOTTOM_SHEET_SCREEN_CONFIG, FullNCFileViewDetailsScreenName, WebDetailsScreenName } from '@v2/pages/common/constants/base.constants';
import NCFileVersionDetails from '@components/ncFileVersions/components/NCFileVersionDetails';
import NCFile from '@components/ncFile';
import NavigatorBottomSheetWrapper from '@components/common/NavigatorBottomSheetWrapper';

const WebDetailsStack = createStackNavigator();

// This navigator is only for web and wraps all details with a single bottom sheet
export const WebDetailsNavigator = () => {
  return (
    <NavigatorBottomSheetWrapper screenNameToRemove={WebDetailsScreenName} bottomSheetId={WebDetailsScreenName}>
      <WebDetailsStack.Navigator
        screenOptions={{
          ...BOTTOM_SHEET_NAVIGATION_CONFIG,
        }}
      >
        <WebDetailsStack.Screen
          name={BatchDetailsScreenName}
          component={BatchDetailsNavigator}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
        <WebDetailsStack.Screen
          name={NCFileDetailsScreenName}
          component={NCFileDetailsNavigator}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
        <WebDetailsStack.Screen
          name={PartDetailsScreenName}
          component={PartDetailsNavigator}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
        <WebDetailsStack.Screen
          name={JobDetailsScreenName}
          component={JobDetailsNavigator}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
        <WebDetailsStack.Screen
          name={ProductionOrderDetailsScreenName}
          component={ProductionOrderDetailsNavigator}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
        <WebDetailsStack.Screen
          name={ToolsDetailsScreenName}
          component={ToolsDetailsNavigator}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
        <WebDetailsStack.Screen
          name="NCFileVersionDetails"
          component={NCFileVersionDetails}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
        <WebDetailsStack.Screen
          name={FullNCFileViewDetailsScreenName}
          component={NCFile}
          options={BOTTOM_SHEET_SCREEN_CONFIG}
        />
      </WebDetailsStack.Navigator>
    </NavigatorBottomSheetWrapper>
  );
};
